import { IWorkspace } from "dto/IWorkspace";

// Osoby do przypisania w builderze workflow = CZŁONKOWIE ZESPOŁU z BE (jedno źródło prawdy),
// nie osobna lista ze schematu organizacyjnego. Identyfikator przypisania = Users.Id członka —
// silnik (WorkflowEngineRepository.ResolveUsers) rozpoznaje go jako Guid; „bezpośredni
// przełożony" to kierownik komórki wnioskodawcy (WorkspaceStructureItems.ManagerUserId).
//
// Builder czyta listę synchronicznie w kilku miejscach (konwertery, mapy etykiet), więc
// trzymamy ją w module — WorkflowModule wypełnia ją po pobraniu firmy (setAssigneePeople).

export type OrgPersonEntry = {
  /** Users.Id członka (albo identyfikator specjalny __requester__/__direct_supervisor__). */
  id: string;
  /** Imię i nazwisko (u pozycji specjalnych — nazwa roli). */
  name: string;
  /** Etykieta prezentowana w builderze: „Imię Nazwisko (stanowisko)". */
  position: string;
  /** Komórka organizacyjna (nazwa) — do rozróżnienia powtórzonych etykiet. */
  unit: string;
  personFullName?: string;
  email?: string;
  memberStatus: "aktywny";
};

let cache: OrgPersonEntry[] = [];

export const setAssigneePeople = (people: OrgPersonEntry[]) => {
  cache = people;
};

/** Członkowie zespołu jako osoby do przypisania (aktualna migawka). */
export const getOrgChartPositions = (): OrgPersonEntry[] => cache;

/** Alias — dawniej osobna lista „ludzi" ze schematu; dziś ta sama lista członków. */
export const getOrgChartPeople = (): OrgPersonEntry[] => cache;

export const membersToAssigneePeople = (
  workspace: IWorkspace | null | undefined,
): OrgPersonEntry[] => {
  if (!workspace) return [];
  const units = new Map((workspace.Structure ?? []).map((s) => [s.Id, s.Name]));
  return (workspace.Members ?? [])
    .filter((m) => !!m.UserId && (m.Status === 4 || m.Status === 1))
    .map((m) => ({
      id: m.UserId,
      name: m.Label,
      position: m.PositionTitle ? `${m.Label} (${m.PositionTitle})` : m.Label,
      unit: (m.StructureId && units.get(m.StructureId)) || "",
      personFullName: m.Label,
      email: m.Email,
      memberStatus: "aktywny" as const,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, "pl"));
};
